import { Component, OnInit } from '@angular/core';
import { PortfolioService } from '../../shared/_services/portfolio.service'
import { DebtorManagement } from '../../shared/models/debtorManagement.model';
import { AuthenticationService } from '../../shared/_services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {

  listMyPortFolio: DebtorManagement[];
  
  error: string;
  p: number = 1;
  idUsuario: number;

  constructor(
    private portfolioService: PortfolioService,
    private _authenService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit() {

    this.idUsuario = this._authenService.currentUserValue.idUser;

    this.portfolioService.getActivePortfoliobyUser(this.idUsuario)
      .subscribe(resultado => {
        this.listMyPortFolio = resultado;
        // ordenamiento descendente de lista de carteras 
        if (this.listMyPortFolio) {
          this.listMyPortFolio.sort((a, b) => {
            return (b.portfolioBalance - a.portfolioBalance);
          });
        }
      }, err => {
          this.error = err;
          this.cleanError();
      })

  }

  getDebtorPortfolio(idDebtor) {
    this.router.navigate(['/portfolio/detail/', idDebtor]);
  }

  //getPhonesFile() {
  //  this._portfolioService.getPhones(this.idUsuario)
  //    .subscribe(res => console.log());
  //}

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }
}
